import { makeStyles } from "tss-react/mui";

export const useStyles = makeStyles()((theme) => ({
    propertyRow: {
        alignItems: "center",
    },
    usbDevicesList: {
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(3),
    },
    usbDeviceTitle: {
        fontWeight: 600,
        marginBottom: theme.spacing(1),
    },
}));
